import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Admissions from './pages/Admissions';
import Staff from './pages/Staff';
import Resources from './pages/Resources';
import ParentsCorner from './pages/ParentsCorner';
import TAGPTA from './pages/TAGPTA';
import VirtualTours from './pages/VirtualTours';
import ComingSoon from './pages/ComingSoon';
import ParentTeacherConferences from './pages/ParentTeacherConferences';
import CurriculumConference from './pages/CurriculumConference';
import routes from './routes.json';
import './index.css';

// Single source of truth for routing lives in src/routes.json.
// To ADD a page: create the component, import it here, add it to `registry`
// below, and add a { path, component, title } entry to src/routes.json
// (prerender.mjs reads the same manifest).
// To REMOVE a page: delete all four (component file, import, registry entry,
// routes.json entry).
const registry = {
  Home,
  About,
  Admissions,
  Staff,
  Resources,
  ParentsCorner,
  TAGPTA,
  VirtualTours,
  ComingSoon,
  ParentTeacherConferences,
  CurriculumConference,
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-slate-50">
        <Navbar />
        <Routes>
          {routes.map(({ path, component }) => {
            const C = registry[component];
            return C ? <Route key={path} path={path} element={<C />} /> : null;
          })}
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
